<script lang="ts">
    import { fly } from "svelte/transition";
  
    import Info from "../Reusables/Info.svelte";
    import Grid from "../Reusables/Grid.svelte";
    import GridCell from "../Reusables/GridCell.svelte";
    import CleanLayout from "../Reusables/CleanLayout.svelte";
    import CleanTopper from "../Reusables/CleanTopper.svelte";
    import CleanFooter from "../Reusables/CleanFooter.svelte";
    import CleanOverlay from "../Reusables/CleanOverlay.svelte";
    import CleanChat from "../Reusables/CleanChat.svelte";
    import type {
      Player,
      WordleState,
      User,
    } from "../../../server/interfaces";
    import { WebSocket, in_game, show_chat, Utils } from "../stores";
    import { fix_state } from "../helpers";
  
    let game: WordleState;
    let self: Player;
    let self_profile: User;
    let text: string = "";
  
    let messages: Array<{
      user: User;
      content: string;
      time: number;
      spectator: boolean;
    }> = [];
  
    let new_message = false;
    $WebSocket.on("OnMessage", (msg) => {
      if (
        messages.length == 0 ||
        messages[messages.length - 1].time != msg.time
      ) {
        messages = messages.concat([msg]);
        new_message = !$show_chat;
      }
    });
  
    let player_count = 0;
    Utils.GameStats.subscribe((e) => {
      if (e) {
        player_count = e.total_players;
      }
    });
  
    $WebSocket.on("OnGameUpdate", (game_state) => {
      let gs = <WordleState>game_state;
      game = gs;
      self = gs.state === "Spectator" ? gs.player : <Player>gs.self;
      if (self) self_profile = self.user;
      in_game.set(true);
      if (game.word){
        text = `the word was ${game.word}`;
      }
    });
  
    function leave_game() {
      $WebSocket.emit("LeaveRoom");
      window.history.replaceState({}, document.title, window.location.pathname);
      in_game.set(false);
  
       game = null;
       self =  null;
       self_profile = null;
    }
  
    function on_create_room(name: string): Promise<string> {
      return new Promise((resolve, reject) => {
        $WebSocket.emit("CreateRoom", name, "Wordle", (room_id) => {
          resolve(room_id);
        });
      });
    }
  
    function on_join_room(room: string, name: string): Promise<string> {
      return new Promise((resolve, reject) => {
        $WebSocket.emit("JoinRoom", room, name, (room_id) => {
          resolve(room_id);
        });
      });
    }
  </script>
  
  <div class="game">
    {#if !$in_game}
      <Info GameName="Wordle" {player_count} {on_create_room} {on_join_room} />
    {:else}
      <CleanLayout GameName="Wordle" show_chat={$show_chat}>
        <CleanTopper
          slot="topper"
          {leave_game}
          room_id={game.room_id}
          spectating={game.state === "Spectator"}
          spectators={game.spectator_count}
        >
          <i
            class={`fas fa-comment${new_message ? "-dots" : ""} ctog`}
            on:click={() => {
              show_chat.set(!$show_chat);
              new_message = false;
            }}
          />
        </CleanTopper>
  
        <CleanChat
          slot="chat"
          w={340}
          h={380}
          m={10}
          {messages}
          send_func={(content) => {
            $WebSocket.emit("SendMessage", content);
          }}
        />
  
        <CleanOverlay
          slot="overlay"
          title={fix_state(self.state)}
          text={text}
          wins_1={self ? self.wins : 0}
          {leave_game}
          rematch={() => $WebSocket.emit("Rematch")}
          show={self.state !== "ongoing"}
          show_history={self.state !== "waiting"}
          show_actions={!(game.state === "Spectator")}
          show_rematch={self.state !== "forfeit"}
        />
  
        <Grid slot="game" x={5} y={6}>
          {#each game.board as row}
            {#each row as column}
            <GridCell
            on_click={()=>{}}
            clickable={false}
            highlight={false}
            class={column.type}
            >
          {column.letter || ""}
          </GridCell>
            {/each}
          {/each}
        </Grid>
  
        <CleanFooter
          slot="footer"
        >
        </CleanFooter>
      </CleanLayout>
    {/if}
  </div>
  
  <style>
    .game {
      overflow: hidden;
    }
  
    .fa-comment-dots {
      animation: float 800ms ease-in-out;
    }
  </style>
  